import React, { useState, useEffect } from "react";
import "./Video.css";
import { TiTimes } from "react-icons/ti";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import Alert from "../../Components/Alert/Alert";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function Video() {
  const [videoUrl, setVideoUrl] = useState("");
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/home_video`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setIsLoading(false);
        setVideoUrl(response.data.link);
      } catch (error) {
        console.log("Error during video url request", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      }
    };
    fetchVideoUrl();
  }, [baseUrl]);

  return (
    <div className="videoPage">
      <div className="videoTimesWrapper centeredFlex" onClick={goBack}>
        <TiTimes className="videoTimesIcon" />
      </div>
      {isLoading ? (
        <Loading />
      ) : (
        <video autoPlay muted className="video">
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      <Alert alertText="خطا در برقراری ارتباط" showAlert={showAlert} />
    </div>
  );
}
